module.exports = __webpack_public_path__ + "img/gender.252fa329.svg";